/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { PopupViews } from '../defines/EnumDefine'
import { ModuleBase } from '@/modules/ModuleBase'

export const BINDACTIVITY_MY = {
  Rewards: 'ဆုလာဘ်များကြိုဆိုပါသည်။',
  FirstReward: '1st Deposit↑ 200%',
  //"LuckyGacha": "ကံကောင်းဂါချာ",
  Pdd: 'နေ့တိုင်း အလကားရနိုင်တဲ့ ငွေကြေး',
  DailyCash: 'နေ့တိုင်းဆုငွေ',
  LuckyWheel: 'ကံကောင်းဘီးလုံး',
  FreeSpinEveryday: 'Free Spin',
  Bonanza: 'Deposit Bonanza',
  WaterWheel: 'Lucky Spin',
  MysticaBox: 'Mystery Treasure',
  //"VipCard": "VIP ကတ်",
  //"Bonus": "အပိုဆု",
  VIPPrivilege: 'VIP အခွင့်ထူး',
  DailyTask: 'DAILY TASK',
}

export const BINDACTIVITY = {
  //"Rewards": "Welcome Rewards",
  Registration: 'Bind Phone', //注册赠送
  FirstReward: 'First Deposit', //首充
  LuckyWheel: 'Lucky Wheel', //实物大转盘
  Pdd: 'Free Rs 2000', //拼多多
  DailyCash: 'Daily Cash', //签到
  Rank: 'Rankings', //排行榜
  DailyTask: 'Daily Task', //每日任务
  Bonanza: 'Deposit Bonanza', //  累计充值
  MysticaBox: 'Mystery Treasure', //神秘宝箱
  WaterWheel: 'Lucky Spin', //累计下注
  FreeSpinEveryday: 'Free Spin', //免费转
  Bonus: 'Diamonds', //钻石转换
  VIPPrivilege: 'VIP Club', //vip权益
  LuckyGems: 'Lucky Gems', //宝石-
  //"VipCard": "VIP Card",      //vip卡
  //"LuckyGacha": "Lucky Gacha",  //扭蛋机
}
export const BINDACTIVITY_PAK = {
  //"Rewards": "خوش آمدید انعامات",
  Registration: 'فون باندھیں', //注册赠送
  FirstReward: 'پہلا ڈپازٹ',
  LuckyWheel: 'لکی وہیل',
  Pdd: 'مفت Rs 2000',
  DailyCash: 'روزانہ کیش',
  Rank: 'رینکنگز', //排行榜
  DailyTask: 'روزانہ ٹاسک',
  Bonanza: 'ڈپازٹ بونانزا',
  MysticaBox: 'مسٹری ٹریژر',
  WaterWheel: 'لکی اسپن',
  FreeSpinEveryday: 'مفت اسپن',
  Bonus: 'ڈائمنڈز',
  VIPPrivilege: 'VIP کلب',
  LuckyGems: 'لکی جیمز', //宝石-
  //"VipCard": "Vip کارڈ",
  //"LuckyGacha": "Lucky  Gacha",
}

//没红点的排序
export enum ActivityList {
  Registration = 0, //注册赠送
  FirstReward = 1, //首充
  LuckyWheel = 2, //实物大转盘
  Pdd = 3, //拼多多
  DailyCash = 4, //签到
  Rank = 5, //排行榜
  DailyTask = 6, //每日任务
  Bonanza = 7, //  累计充值
  MysticaBox = 8, //神秘宝箱
  WaterWheel = 9, //累计下注
  FreeSpinEveryday = 10, //免费转
  Bonus = 11, //钻石转换
  VIPPrivilege = 12, //vip权益
  LuckyGems = 13, //宝石
}

//有红点的排序
export enum ActivityListRed {
  Registration = 0, //注册赠送
  FirstReward = 1, //首充
  LuckyWheel = 2, //实物大转盘
  Pdd = 3, //拼多多
  DailyCash = 4, //签到
  Rank = 5, //排行榜
  FreeSpinEveryday = 6, //免费转
  Bonus = 7, //钻石转换
  DailyTask = 8, //每日任务
  Bonanza = 9, //  累计充值
  MysticaBox = 10, //神秘宝箱
  WaterWheel = 11, //累计下注
  VIPPrivilege = 12, //vip权益
  LuckyGems = 13, //宝石
}

export class BindActivityModule extends ModuleBase {
  public redStatus = false //当前侧边栏红点状态
  public welComeinit = [0, 0, 0] //新人礼包初始哪个已经充值

  public RegistrationRed = false
  public welcomeisRed = false
  public signRed = false
  public diamondRed = false
  public vipCardRed = false
  public vipEquityRed = false
  public eggCapsuleRed = false
  public turnTableRed = false
  public pddRed = false
  public FirstRewardRed = false
  public WaterWheelRed = false
  public BonanzaRed = false
  public DailyTaskRed = false
  public MysticaBoxRed = false
  public freeSpinRed = false
  public rankRed = false
  public isHaveRed = false
  public gemsRed = false

  public activityList: any = [] //活动排序的列表(ActivityList为准)
  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  onPreloadData(): void {}

  inits2c(): void {}

  creatorRedStatus() {
    //新人礼包是激活才红的，每次进界面都会刷新数据，所以要单独判断
    this.welComeinit = hall.welcomeGiftModule.welcomeStatusRed()
  }

  changeRedStatus() {
    //判断每个状态是否都是红的
    //1，列表内有一个红点出现，则外部就出现红点
    //2，新手礼包红点
    //激活1充，2充，3充时出现红点，玩家点击后消失
    //3，签到红点
    //有可领取的金额时红点，玩家领取后消失
    //4，钻石转化弹框
    //有可领取的金额时红点，玩家领取后消失
    //5，VIP卡活动
    //有可领取金额时出现红点，领取后消失
    //6，VIP权益入口
    //有可领取奖励时出现，升级奖励，负盈利，周、半月、月奖励，无可领取的消失
    //7，扭蛋机活动
    //一直有红点，一直到活动失效或者玩家完成领取奖励后消失
    this.RegistrationRed = false
    this.redStatus = false
    this.welcomeisRed = false
    this.signRed = false
    this.diamondRed = false
    this.vipCardRed = false
    this.vipEquityRed = false
    this.eggCapsuleRed = false
    this.turnTableRed = false
    this.pddRed = false
    this.FirstRewardRed = false
    this.WaterWheelRed = false
    this.BonanzaRed = false
    this.DailyTaskRed = false
    this.MysticaBoxRed = false
    this.freeSpinRed = false
    this.rankRed = false
    this.gemsRed = false

    const redWelcome = hall.welcomeGiftModule.getRedstatus() //新人礼包可充值
    for (let i = 0; i < redWelcome.length; i++) {
      if (redWelcome[i] == 1 && this.welComeinit[i] == 0) {
        this.welcomeisRed = true
      }
    }

    this.RegistrationRed = !hall.userModule.hasBoundPhoneNum()
    this.signRed = hall.signModule.isCanSign()
    this.diamondRed = hall.vipEquityModule.getVipDiamondRed()
    this.vipCardRed = hall.vipDailyCashModule.canGetRewardNow()
    this.vipEquityRed = hall.vipEquityModule.getVipEquityRed()
    this.eggCapsuleRed = hall.eggCapsuleModule.getEggCapsuleRed()
    this.turnTableRed = hall.turnTableModule.isShowTurnBind()
    this.pddRed = hall.pinDuoModule.isShowPddRed()
    this.FirstRewardRed = hall.addCashModule.isShowFirstBind()
    this.WaterWheelRed = hall.waterWheelModule.isShowWaterWheelBind()
    this.BonanzaRed = hall.bonanzaModule.isShowBonanzaBind()
    this.DailyTaskRed = hall.dailyTaskModule.isShowDailyRed()
    this.MysticaBoxRed = hall.mysticaBoxModule.isShowBoxRed()
    this.freeSpinRed = hall.freeSpinModule.nFreeSpinCount != 0
    this.rankRed = hall.rankModule.rankRed
    this.gemsRed = hall.jackpotGamsModule.isShowJackPotRed()

    if (
      this.welcomeisRed == true ||
      this.RegistrationRed == true ||
      this.signRed == true ||
      this.diamondRed == true ||
      this.vipCardRed == true ||
      this.vipEquityRed == true ||
      this.eggCapsuleRed == true ||
      this.turnTableRed == true ||
      this.pddRed == true ||
      this.FirstRewardRed == true ||
      this.WaterWheelRed == true ||
      this.BonanzaRed == true ||
      this.DailyTaskRed == true ||
      this.MysticaBoxRed == true ||
      this.freeSpinRed == true ||
      this.rankRed == true ||
      this.gemsRed == true
    ) {
      this.redStatus = true
    }
    this.paixu()
  }

  paixu() {
    //排序，先排序红的，剩下的再排序白的
    const arr = [] //有红点的活动
    if (this.RegistrationRed == true) {
      arr.push(ActivityList.Registration)
    }
    if (this.FirstRewardRed == true) {
      arr.push(ActivityList.FirstReward)
    }
    if (this.turnTableRed == true) {
      arr.push(ActivityList.LuckyWheel)
    }
    if (this.pddRed == true) {
      arr.push(ActivityList.Pdd)
    }
    if (this.signRed == true) {
      arr.push(ActivityList.DailyCash)
    }
    if (this.DailyTaskRed == true) {
      arr.push(ActivityList.DailyTask)
    }
    if (this.BonanzaRed == true) {
      arr.push(ActivityList.Bonanza)
    }
    if (this.MysticaBoxRed == true) {
      arr.push(ActivityList.MysticaBox)
    }
    if (this.WaterWheelRed == true) {
      arr.push(ActivityList.WaterWheel)
    }
    if (this.freeSpinRed == true) {
      arr.push(ActivityList.FreeSpinEveryday)
    }
    if (this.diamondRed == true) {
      arr.push(ActivityList.Bonus)
    }
    if (this.vipEquityRed == true) {
      arr.push(ActivityList.VIPPrivilege)
    }
    if (this.rankRed == true) {
      arr.push(ActivityList.Rank)
    }
    if (this.gemsRed == true) {
      arr.push(ActivityList.LuckyGems)
    }
    this.isHaveRed = arr.length > 3

    this.activityList = this.processActivityList(arr)

    //入口消失
    if (this.FirstRewardRed == false) {
      this.removeItem(this.activityList, ActivityList.FirstReward)
    }
    if (this.RegistrationRed == false) {
      this.removeItem(this.activityList, ActivityList.Registration)
    }
    if (this.turnTableRed == false) {
      this.removeItem(this.activityList, ActivityList.LuckyWheel)
    }
    const gemsInfp = hall.jackpotGamsModule.isShowJackPotBind()
    if (!gemsInfp) {
      this.removeItem(this.activityList, ActivityList.LuckyGems)
    }
    hall.eventDispatcher.emit(hall.EventDefine.ChangeActivityRed) //刷新活动列表
  }

  removeItem<T>(array: T[], value: T): boolean {
    const index = array.indexOf(value)
    if (index > -1) {
      array.splice(index, 1)
      return true
    }
    return false
  }

  processActivityList(redDotSortedIds: number[]): number[] {
    // 1. 获取所有可能的活动名称 (Key)，作为桥梁
    // Object.keys 会返回字符串形式的键名 ["Registration", "FirstReward", ...]
    const allKeys = Object.keys(ActivityList).filter((key) =>
      isNaN(Number(key)),
    ) as (keyof typeof ActivityList)[]

    // 2. 转换红点数组：Red ID -> Name -> Old ID
    const convertedRedIds = redDotSortedIds.map((redId) => {
      // 找到这个 Red ID 对应的活动名称
      // 逻辑：遍历所有 Key，看哪个 Key 在 ActivityListRed 里的值等于 redId
      const key = allKeys.find((k) => ActivityListRed[k] === redId)

      if (!key) {
        throw new Error(`无效的 Red ID: ${redId}`)
      }

      // 通过名称拿到 ActivityList 的 ID
      return ActivityList[key]
    })

    // 3. 获取剩余活动 (无红点)
    // 全集是 0-11 (ActivityList 的值)
    const allOldIds = Object.values(ActivityList).filter((v) => typeof v === 'number') as number[]

    const remainingIds = allOldIds.filter((id) => !convertedRedIds.includes(id))

    // 4. 剩余活动按 ActivityList 原始顺序排序 (其实就是从小到大，因为枚举定义就是连续的)
    remainingIds.sort((a, b) => a - b)

    // 5. 合并：转换后的红点组 (前) + 剩余组 (后)
    return [...convertedRedIds, ...remainingIds]
  }

  changeWelcomeRed() {
    if (this.welcomeisRed == true) {
      for (let i = 0; i < this.welComeinit.length; i++) {
        if (this.welComeinit[i] == 0) {
          this.welComeinit[i] = 1
          return
        }
      }
    }
  }

  // 是否需要弹窗
  popupView() {
    // 增加主动弹出逻辑，每天弹出一次，在其它弹框权重后面
    hall.popupViewModule.addPopupView(PopupViews.NewBindActivityPanel)
  }
}
